if ($('.js-data-table-training-results').length) {
    let tableTrainingResults = $('.js-data-table-training-results').DataTable(
        returnDataTableTrainingResultsOptions(
            trainingSearchResultsDataArray,
            [2, 5, 1],
            ['Date', 'Time']
        )
    );

    initTrainingResultsFunctionSet(tableTrainingResults);
}

if ($('.js-data-table-training-results-from-mountain').length) {
    let tableTrainingResults = $(
        '.js-data-table-training-results-from-mountain'
    ).DataTable(
        returnDataTableTrainingResultsOptions(
            trainingSearchResultsDataArray,
            [2, 5],
            ['Date', 'Time']
        )
    );

    initTrainingResultsFunctionSet(tableTrainingResults);
}

if ($('.js-data-table-training-results-from-mountain-only-tod').length) {
    let tableTrainingResults = $(
        '.js-data-table-training-results-from-mountain-only-tod'
    ).DataTable(
        returnDataTableTrainingResultsOptions(
            trainingSearchResultsDataArray,
            [2],
            ['Date']
        )
    );

    initTrainingResultsFunctionSet(tableTrainingResults);
}
